/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const apiConfig = {
  gql: {
    url: 'https://poc-api-irdai.klefki.io.klefki.io/scooby-gql/',
  },
  rest: {
    url: 'https://poc-api-irdai.klefki.io.klefki.io/scooby-iam',
  },
  sendOTPEP: '/user/sign-up',
  SignInUserEP: '/user/sign-in',
  accessTokenEP: '/user/access-token/get',
  baseURL: '',
  scriptURL: 'https://checkout.razorpay.com/v1/checkout.js',
  keyId: 'rzp_test_zMlQ6S29QkhjEK',
};
